import {get} from '../../lib/apiClient'


export async function getList(documentClass: string): Promise<string[]> {
  return get<string[]>(`json-documents/${documentClass}`)
}
